import { css } from "@emotion/react";
import { isUndefined } from "lodash";
import { ProjectFolderDjango } from "pages/gdt/folders/ProjectFoldersProvider.api";
import { DataTableStoreState } from "pages/gdt/store/DataTableProvider.types";
import { isDefined } from "utils/isDefined";

export const getTableMenuItems = (
  tables: DataTableStoreState["tables"][number][],
  folders: ProjectFolderDjango[],
  selectedTableId: string | undefined,
  setSelectedTableId: (tableId: string) => void,
) => {
  const {
    tableItems,
    tablesByFolder,
  }: {
    tableItems: { title: string; onClick: () => void; isSelected: boolean }[];
    tablesByFolder: Record<
      string,
      { title: string; onClick: () => void; isSelected: boolean }[]
    >;
  } = [...tables]
    .sort((a, b) => a.name.localeCompare(b.name))
    // remove hidden tables
    .filter(({ hidden }) => !hidden)
    .reduce<{
      tableItems: { title: string; onClick: () => void; isSelected: boolean }[];
      tablesByFolder: Record<
        string,
        { title: string; onClick: () => void; isSelected: boolean }[]
      >;
    }>(
      (acc, table) => {
        // Check if the table has a folder
        // If it does, add it to the folder
        // If it doesn't, add it to the table items
        const folderId = table.folder;
        if (folderId !== null && isDefined(folderId)) {
          const folder = folders.find((f) => f.id === folderId);
          if (isDefined(folder)) {
            if (isUndefined(acc.tablesByFolder[folderId])) {
              acc.tablesByFolder[folderId] = [];
            }
            acc.tablesByFolder[folderId].push({
              title: table.name,
              onClick: () => {
                setSelectedTableId(table.id);
              },
              isSelected: table.id === selectedTableId,
            });
          }
        }
        // If the table doesn't have a folder, add it to the table items
        else {
          acc.tableItems.push({
            title: table.name,
            onClick: () => {
              setSelectedTableId(table.id);
            },
            isSelected: table.id === selectedTableId,
          });
        }
        return acc;
      },
      { tableItems: [], tablesByFolder: {} },
    );

  // always show folders by name alphabetically ascending
  const sortedFolders = [...folders].sort((a, b) =>
    a.name.localeCompare(b.name),
  );
  const folderItems = sortedFolders
    .map((folder) => {
      const tablesInFolder = tablesByFolder[folder.id];
      if (isDefined(tablesInFolder)) {
        return {
          title: folder.name,
          isCollapsible: true,
          accordionProps: {
            initialIsOpen: true,
          },
          items: tablesInFolder,
          css:
            folder.color !== null
              ? css`
                  color: ${folder.color}!important;
                `
              : undefined,
        };
      } else return undefined;
    })
    .filter(isDefined);
  return [...folderItems, ...tableItems];
};
